Vue.component("additional-costs",
    {
        template: "#vue-additional-costs",

        computed: {
            ...Vuex.mapState(
                {
                    additionalCosts: state => state.assistant.additionalCosts,
                    biPlanList: state => state.assistant.biPlans
                }
            ),
            ...Vuex.mapGetters(
                {
                    isAdditionalItem:   "isAdditionalItem",
                    trans: "getTranslation"
                }
            )
        },

        methods: {

            /**
             * Filter if is a additional coasts item
             * @param module
             * @returns {*}
             */
            isAdditionalItemFilter(module)
            {
                return this.isAdditionalItem(module.$value) && !this.biPlanList[module.$value.data.item.id];
            }
        }
    });

